import React from 'react';
import { FiChevronLeft, FiFileText } from 'react-icons/fi';
import { IoIosHelpCircleOutline } from 'react-icons/io';
const RegisterationHeader = ({ heading,handlePrevious }) => (
    <div className="flex justify-between items-center">
    <div className="flex items-center gap-1">
      <FiChevronLeft
        className="font-semibold text-coalBlack cursor-pointer duration-100 ease-in-out"
        size={30}
        onClick={handlePrevious}
      />
      <p className="capitalize text-2xl !md:text-base font-medium text-coalBlack">
        {heading}
      </p>
    </div>
  </div>
  
);

export default RegisterationHeader;
